// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__10clF","row":"style_row__Wmzz6","title":"style_title__esS1h","outlined":"style_outlined__-S7_0"};